import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { FeatureFlagRecord } from "../FeatureFlagRecord";

import { featureFlagQueryKeys } from "./featureFlagQueryKeys";
import * as UseDeletedFeatureFlags from "./useDeletedFeatureFlags";
import * as UseFeatureFlags from "./useFeatureFlags";

export function useRestoreFeatureFlag() {
  const { featureFlagService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<FeatureFlagRecord, Error, string>({
    mutationFn: (featureFlagId) => featureFlagService.restore(featureFlagId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseFeatureFlags.getQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: UseDeletedFeatureFlags.getQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: featureFlagQueryKeys.states(),
      });
    },
  });
}
